import { defineStore } from "pinia";
import _ from 'lodash';
import type { ISettingVm } from "@/types/ISettingVm";
export const useSettingStore = defineStore({
    id: "usesettingStore",
    state: () => ({
        setting: {} as ISettingVm,
        isLoadingSetting: false
    }),
    getters: {},
    actions: {
        async getSetting() {
            if(this.isLoadingSetting) {
                return;    
            }

            if(Object.keys(this.setting).length > 0) {
                return;
            }

            this.isLoadingSetting = true;
            try {
                var url = `/api/Participation/GetParticipationSettings`;
                const response = await this.axiosFactory.withoutToken().get(url);
                this.setting = response.data;
            } catch (error: any) {
                console.log(error.response)
            } finally {
                this.isLoadingSetting = false;
            }
        },
    }
});
